<template>
  <v-card>
    <v-card-title>
      {{ $t('ticketingSystem.charts.completedTasksByAssigneeTitle') }}
    </v-card-title>
    <v-card-text v-if="hasProcessDefinitionKeysChecked">
      <v-progress-linear v-if="$apollo.loading" color="blue" indeterminate></v-progress-linear>
      <v-container fluid v-else-if="searchTicketingCompletedTasksByAssigneeStatistics">
        <v-row>
          <v-col>
            <BarChart
              :chart-options="chart.options"
              :chart-data="chart.data"
              :height="600"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import BarChart from './../../../components/charts/BarChart'
import { getIntervalLabels } from '@/helpers/momentHelper'
import { mapActions, mapState } from 'vuex'
import { SEARCH_TICKETING_COMPLETED_TASKS_BY_ASSIGNEE } from '@/features/ticketing-statistics/graphql-apollo/searchTicketing.gql'

export default {
  name: 'CompletedTasksByAssignee',
  components: {
    BarChart
  },
  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },
  apollo: {
    searchTicketingCompletedTasksByAssigneeStatistics: {
      query: SEARCH_TICKETING_COMPLETED_TASKS_BY_ASSIGNEE,
      variables () {
        return {
          from: this.filters.from,
          to: this.filters.to,
          interval: this.filters.interval.toUpperCase(),
          processDefinitionKeys: this.filters?.processDefinitionKeys
        }
      },
      skip () {
        return this.filters === null || this.filters?.processDefinitionKeys?.length === 0
      }
    }
  },
  async created () {
    if (this.ticketingUsers?.length === 0) {
      await this.loadTicketingUsers()
    }
  },
  computed: {
    ...mapState('ticketingSystem', ['ticketingUsers']),
    chart () {
      return {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: 'index',
            intersect: false
          },
          plugins: {
            datalabels: {
              backgroundColor: function(context) {
                return context.dataset.backgroundColor
              },
              display: function(context) {
                return context.dataset.data[context.dataIndex] > 0
              },
              borderRadius: 4,
              color: 'white',
              formatter: Math.round,
              padding: 3
            }
          },
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true
            }
          }
        },
        data: {
          labels: this.getLabels(),
          datasets: this.searchTicketingCompletedTasksByAssigneeStatistics.map(user => {
            return {
              label: this.getUser(user.userId),
              data: user.tasksCompleted.map(x => x.count)
            }
          })
        }
      }
    },
    hasProcessDefinitionKeysChecked () {
      return this.filters && this.filters.processDefinitionKeys.length > 0
    }
  },
  methods: {
    ...mapActions('ticketingSystem', ['loadTicketingUsers']),
    getUser(id) {
      const found = this.ticketingUsers.find(item => item.userId === id)
      if (found) {
        return found.name
      }
      return id
    },
    getLabels () {
      if (this.searchTicketingCompletedTasksByAssigneeStatistics.length > 0) {
        return getIntervalLabels(this.searchTicketingCompletedTasksByAssigneeStatistics[0].tasksCompleted, this.filters?.interval.toUpperCase())
      } else {
        this.$emit('hideCompletedTasksByAssigneeChartData', false)
        return null
      }
    }
  }
}
</script>
